import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next' //语言包

import { Popconfirm, Tooltip, Button, Typography, Space, Drawer } from 'antd'
import { ExclamationCircleOutlined, FormOutlined, HistoryOutlined, SettingOutlined, SaveOutlined, ArrowUpOutlined, PlusOutlined, SwapOutlined, BarChartOutlined, CloseOutlined } from '@ant-design/icons'
import IconSvg from '../IconSvg'
import { BackToTopIconWrapper, SwitchIconWrapper, DelectIconWrapper, EditIconWrapper, ResetIconWrapper, TransformIconWrapper, SetIconWrapper, ChartIconWrapper, FoldIconWrapper, SyncWrapper, SaveIconWrapper, DetailWrapper, CopyIconWrapper, LinkTextWrapper, BlockWrapper, UnblockWrapper, ListWrapper, AddWrapper, EditWrapper, VerifyWrapper, DownloadWrapper, GenerateWrapper, ViewWrapper, BlockButton, NoticeBtn, DownIcon,CreateWrapper, CancelIconWrapper, SaveIconWrapper1 } from './style'

import { MiniWarning } from '../mininote'
import { props } from 'ramda'
import {useNavigate} from "react-router-dom";
import  CurrentAlarmTableList  from "../currentAlarmTableList/CurrentAlarmTableList";
import { SoundOutlined } from '@ant-design/icons';

/* 返回顶部 Icon */
const BackToTopIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <BackToTopIconWrapper onClick={props.onClick} style={props.style}>
        <Tooltip placement='top' title={t('All.Operation.goToTop')}>
          <Button type='primary' shape='circle' icon={<ArrowUpOutlined />} onClick={props.onClick} />
        </Tooltip>
      </BackToTopIconWrapper>
    </>
  )
}

/* 切换 Icon */
const SwitchIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <SwitchIconWrapper>
        <Tooltip placement='top' title={t('All.Operation.switch')}>
          <Button shape='circle' icon={<IconSvg icon='fal fa-angle-right' />} onClick={props.onClick} />
        </Tooltip>
      </SwitchIconWrapper>
    </>
  )
}

/* 删除 Icon */
const DelectIconOperation = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  useEffect(() => {
    if (props.isShow !== undefined && props.isShow !== '') {
      setIsShow(props.isShow)
    } else {
      setIsShow(true)
    }
  }, [props.isShow])
  useEffect(() => {
    if (props.disabled !== undefined && props.disabled !== '') {
      setIsDisabled(props.disabled)
    } else {
      setIsDisabled(false)
    }
  }, [props.disabled])

  if (props.isPop === undefined || props.isPop) {
    return (
      <>
        <DelectIconWrapper className={`${isShow ? 'Show' : 'isHide'} ${props.type || ''}`}>
          <Popconfirm
            placement='left'
            title={<MiniWarning text={t('All.Result.Popconfirm.reconfirm')} />}
            cancelText={t('All.Operation.cancel')}
            okText={t('All.Operation.submit')}
            okType='danger'
            disabled={props.disabled || false}
            onConfirm={props.delectClick}
            icon={false}
          >
            <Tooltip placement='top' title={props.type === 'asIcon' ? '' : t('All.Operation.delete')}>
              <Button disabled={isDisabled} {...props}><IconSvg icon='fal fa-trash-alt' /></Button>
            </Tooltip>
          </Popconfirm>
        </DelectIconWrapper>
      </>
    )
  } else {
    return (
      <>
        <DelectIconWrapper className={isShow ? 'Show' : 'isHide'}>
          <Button onClick={props.delectClick}><IconSvg icon='fal fa-trash-alt' /></Button>
        </DelectIconWrapper>
      </>
    )
  }
}

/* 修改 Icon */
const EditIconOperation = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  useEffect(() => {
    if (props.isShow !== undefined && props.isShow !== '') {
      setIsShow(props.isShow)
    } else {
      setIsShow(true)
    }
  }, [props.isShow])
  useEffect(() => {
    if (props.isDisabled !== undefined && props.isDisabled !== '') {
      setIsDisabled(props.isDisabled)
    } else {
      setIsDisabled(false)
    }
  }, [props.isDisabled])
  return (
    <>
      <EditIconWrapper className={`${isShow ? 'Show' : 'isHide'} ${props.type || ''} ${props.iconSize || ''}`}>
        <Tooltip placement='top' title={props.type === 'asIcon' ? '' : t('All.Operation.edit')}>
          <Button disabled={isDisabled} onClick={props.editClick} {...props}><IconSvg icon='fal fa-pencil' /></Button>
        </Tooltip>
      </EditIconWrapper>
    </>
  )
}

/* 重置 Icon */
const ResetIconOperation = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (props.isShow !== undefined && props.isShow !== '') {
      setIsShow(props.isShow)
    } else {
      setIsShow(true)
    }
  }, [props.isShow])
  useEffect(() => {
    if (props.isDisabled !== undefined && props.isDisabled !== '') {
      setIsDisabled(props.isDisabled)
    } else {
      setIsDisabled(false)
    }
  }, [props.isDisabled])

  if (props.confirm || props.confirm === undefined) {
    return (
      <>
        <ResetIconWrapper className={` ${isShow ? 'Show' : 'isHide'} ${props.type}`} >
          <Popconfirm
            placement='left'
            title={<MiniWarning text={t('All.Result.Popconfirm.reconfirm')} />}
            cancelText={t('All.Operation.cancel')}
            okText={t('All.Operation.submit')}
            okType='danger'
            disabled={props.disabled || false}
            onConfirm={props.reductClick}
            icon={false}
          >
            <Tooltip placement='top' title={props.type === 'asIcon' ? '' : t('All.Operation.reset')}>
              <Button disabled={isDisabled} size={props.size || 'small'} shape='circle' icon={<HistoryOutlined />} {...props} />
            </Tooltip>
          </Popconfirm>
        </ResetIconWrapper>
      </>
    )
  } else {
    return (
      <>
        <ResetIconWrapper className={` ${isShow ? 'Show' : 'isHide'} ${props.type}`}>
          <Tooltip placement='top' title={props.type === 'asIcon' ? '' : t('All.Operation.reset')}>
            <Button disabled={isDisabled} size={props.size || 'small'} shape='circle' icon={<HistoryOutlined />} onClick={props.reductClick} {...props} />
          </Tooltip>
        </ResetIconWrapper>
      </>
    )
  }
}

/* 转让 Icon */
const TransformIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <TransformIconWrapper>
        <Tooltip placement='top' title={t('All.Operation.transform')}>
          <Button onClick={props.transferenceClick}><IconSvg icon='fal fa-house-user' /></Button>
        </Tooltip>
      </TransformIconWrapper>
    </>
  )
}

/* 同步 */
const SyncOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <SyncWrapper className={props.type}>
        <Tooltip placement='top' title={props.toolText || ''}>
          <Button size='default' shape='round' type='primary' icon={<SwapOutlined />}>{t('All.Operation.sync')}</Button>
        </Tooltip>
      </SyncWrapper>
    </>
  )
}

/* 设置 */
const SetIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <SetIconWrapper>
        <Tooltip placement='top' title={t('All.Operation.Set.set')}>
          <Button size={props.size || 'small'} shape='circle' type='primary' icon={<SettingOutlined />} onClick={props.setClick} />
        </Tooltip>
      </SetIconWrapper>
    </>
  )
}

/* 保存 */
const SaveIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <SaveIconWrapper className={props.type}>
        <Tooltip placement='top' title={t('All.Note.Tips.Tooltip.save')}>
          <Button size='small' shape='circle' disabled={props.disabled || false} type='primary' icon={<SaveOutlined />} onClick={props.saveClick} />
        </Tooltip>
      </SaveIconWrapper>
    </>
  )
}

/* 折叠 */
const FoldIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <FoldIconWrapper className={props.isShowExpand ? 'isShow' : 'isHide'}>
        <Button
          type='default'
          shape='round'
          icon={props.icon}
          onClick={props.onClick}

        >
          <Typography.Text>{props.text}</Typography.Text>
        </Button>
      </FoldIconWrapper>
    </>
  )
}

/* 查看图表 */
const ChartIconOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <ChartIconWrapper>
        <Tooltip placement='top' title={t('All.Note.Tips.Tooltip.detail')}>
          <Button icon={<BarChartOutlined />} {...props}></Button>
        </Tooltip>
      </ChartIconWrapper>
    </>
  )
}

/* 详情 */
const DetailOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <DetailWrapper>
        <Button type='primary' shape='round' onClick={props.detailClick} >{props.text || t('All.Operation.detail')}</Button>
      </DetailWrapper>
    </>
  )
}

/* 复制 */
const CopyOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <CopyIconWrapper>
        <Typography.Text
          title={props.carrierContent}
          copyable={{
            tooltips: [t('All.Note.Tips.Tooltip.copy'), t('All.Note.Tips.Tooltip.copied')],
            text: props.carrierContent
          }}
        >
          <span className='limitingWidth maxWidth264'>
            {props.carrierContent}
          </span>
        </Typography.Text>
      </CopyIconWrapper>
    </>
  )
}

/* 外链文本 */
const LinkTextOperation = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  useEffect(() => {
    if (props.isShow !== undefined && props.isShow !== '') {
      setIsShow(props.isShow)
    } else {
      setIsShow(true)
    }
  }, [props.isShow])
  return (
    <>
      <LinkTextWrapper>
        <Tooltip placement='top' title={props.tooltipText} className={isShow ? 'isShow' : 'isHide'}>
          <Button type='link' {...props}>
            {props.linkText}
          </Button>
        </Tooltip>
      </LinkTextWrapper>
    </>
  )
}

/* 屏蔽 */
const BlockOperation = (props) => {
  const { t } = useTranslation();
  const [okHover, setOkHover] = React.useState(false);
  const [cancelHover, setCancelHover] = React.useState(false);

  const isAlarmPage = window.location.href.includes('/alarm');
  const getContainer = React.useMemo(() => {
    return () => document.body;
  }, []);
  return (
    <>
      <BlockWrapper>
        <Popconfirm
          overlayClassName="ant-popconfirm"
          disabled={props.isDis || false}
          placement='left'
          title={<MiniWarning text={t('All.Result.Popconfirm.reconfirm')} />}
          cancelText={t('All.Operation.cancel')}
          okText={t('All.Operation.submit')}
          okType='danger'
          zIndex={100000}
          okButtonProps={{
            style: {
              borderRadius: '6px !important',
              height: '24px',
              width: "auto",
              minWidth: '43.34px',
              minHeight: '24px',
              lineHeight: '22px',
              padding: '0 12px',
              borderRadius: '6px',
              backgroundColor: okHover ? '#ff4d4f' : '#fff',
              border: `1px solid ${okHover ? '#ff4d4f' : '#ff4d4f'}`,
              color: okHover ? '#fff' : '#ff4d4f',
              transition: 'all .3s',
            },
            onMouseEnter: () => setOkHover(true),
            onMouseLeave: () => setOkHover(false),
          }}
          cancelButtonProps={{
            style: {
              borderRadius: '6px !important',
              height: '24px',
              width: "auto",
              minWidth: '43.34px',
              minHeight: '24px',
              lineHeight: '22px',
              padding: '0 12px',
              backgroundColor: '#fff',
              border: `1px solid ${cancelHover ? 'var(--sky-55)' : 'var(--black-885)'}`,
              color: cancelHover ? '#1890ff' : '#262626',
              transition: 'all .3s',
            },
            onMouseEnter: () => setCancelHover(true),
            onMouseLeave: () => setCancelHover(false),
          }}
          icon={false}
          onConfirm={props.onConfirm}
          // getPopupContainer={trigger => trigger.parentElement}
          // getPopupContainer={() => document.body}
          getPopupContainer={getContainer}

          align={{
            overflow: { adjustX: false, adjustY: false },
          }}
        >
          <BlockButton disabled={props.isDis || false}>
            {t('All.Operation.block')}
          </BlockButton>
        </Popconfirm>
      </BlockWrapper>
    </>
  )
}

/* 取消屏蔽 */
const UnblockOperation = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  useEffect(() => {
    if (props.isShow !== undefined && props.isShow !== '') {
      setIsShow(props.isShow)
    } else {
      setIsShow(true)
    }
  }, [props.isShow])
  useEffect(() => {
    if (props.isDisabled !== undefined && props.isDisabled !== '') {
      setIsDisabled(props.isDisabled)
    } else {
      setIsDisabled(false)
    }
  }, [props.isDisabled])
  return (
    <>
      <UnblockWrapper className={isShow ? 'Show' : 'Hide ClearWidth'}>
        <Popconfirm
          disabled={props.isDis || false}
          placement='left'
          title={<MiniWarning text={t('All.Result.Popconfirm.reconfirm')} />}
          cancelText={t('All.Operation.cancel')}
          okText={t('All.Operation.submit')}
          okType='danger'
          icon={false}
          onConfirm={props.onConfirm}
        >
          <Button disabled={props.isDis || false}>{t('All.Operation.unblock')}</Button>
        </Popconfirm>
      </UnblockWrapper>
    </>
  )
}

/* 列表弹框操作按钮 */
const ListOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <ListWrapper>
        <Tooltip placement='top' title={props.tooltipText || ''}>
          <Button type='primary' {...props} >
            {props.btnText}
          </Button>
        </Tooltip>
      </ListWrapper>
    </>
  )
}

/* 新增 */
const AddOperation = (props) => {
  const { t } = useTranslation();
  const [tooltipText, setTooltipText] = useState('');
  useEffect(() => {
    if (props.tooltipType === 'tooltipWarning' && props.tooltipText !== '') {
      setTooltipText(<>
        <Space>
          <ExclamationCircleOutlined />
          <Typography.Text>{props.tooltipText}</Typography.Text>
        </Space>
      </>)
    } else {
      setTooltipText(props.tooltipText)
    }
  }, [props.tooltipType, props.tooltipText])

  return (
    <>
      <AddWrapper className={props.type}>
        <Tooltip
          placement='top'
          title={tooltipText || ''}
          overlayClassName={props.tooltipType || ''}
        >
          <Button type='dashed' icon={<PlusOutlined />} {...props}>
            {props.btnText}
          </Button>
        </Tooltip>
      </AddWrapper>
    </>
  )
}

/* 通知 */
const NoticeOperation = (props) => {
  const { t } = useTranslation();
  const [tooltipText, setTooltipText] = useState('');
  useEffect(() => {
    if (props.tooltipType === 'tooltipWarning' && props.tooltipText !== '') {
      setTooltipText(<>
        <Space>
          <ExclamationCircleOutlined />
          <Typography.Text>{props.tooltipText}</Typography.Text>
        </Space>
      </>)
    } else {
      setTooltipText(props.tooltipText)
    }
  }, [props.tooltipType, props.tooltipText])

  return (
    <>
      <AddWrapper className={props.type}>
        <Tooltip
          placement='top'
          title={tooltipText || ''}
          overlayClassName={props.tooltipType || ''}
        >
          <NoticeBtn type='dashed' icon={<SoundOutlined />} {...props}>
            {props.btnText}
          </NoticeBtn>
        </Tooltip>
      </AddWrapper>
    </>
  )
}

/* 下载帮助文档 */
const DownloadHelpOperation = (props) => {
  const { t } = useTranslation();
  const [tooltipText, setTooltipText] = useState('');
  useEffect(() => {
    if (props.tooltipType === 'tooltipWarning' && props.tooltipText !== '') {
      setTooltipText(<>
        <Space>
          <ExclamationCircleOutlined />
          <Typography.Text>{props.tooltipText}</Typography.Text>
        </Space>
      </>)
    } else {
      setTooltipText(props.tooltipText)
    }
  }, [props.tooltipType, props.tooltipText])

  return (
    <>
      <AddWrapper className={props.type}>
        <Tooltip
          placement='top'
          title={tooltipText || ''}
          overlayClassName={props.tooltipType || ''}
        >
          <Button type='dashed' icon={<DownIcon />} {...props}>
            {props.btnText}
          </Button>
        </Tooltip>
      </AddWrapper>
    </>
  )
}

/* 修改 */
const EditOperation = (props) => {
  const { t } = useTranslation();
  const [tooltipText, setTooltipText] = useState('');
  useEffect(() => {
    if (props.tooltipType === 'tooltipWarning' && props.tooltipText !== '') {
      setTooltipText(<>
        <Space>
          <ExclamationCircleOutlined />
          <Typography.Text>{props.tooltipText}</Typography.Text>
        </Space>
      </>)
    } else {
      setTooltipText(props.tooltipText)
    }
  }, [props.tooltipType, props.tooltipText])

  return (
    <>
      <EditWrapper className={props.type}>
        <Tooltip
          placement='top'
          title={tooltipText || ''}
          overlayClassName={props.tooltipType || ''}
        >
          <Button type="default" icon={<FormOutlined />} {...props}>
            {props.btnText}
          </Button>
        </Tooltip>
      </EditWrapper>
    </>
  )
}

/* 验证 */
const VerifyOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <VerifyWrapper>
        <Button type='primary' size='large' {...props}>
          {t('All.Operation.verify')}
        </Button>
      </VerifyWrapper>
    </>
  )
}

/* 下载 */
const DownloadOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <DownloadWrapper>
        <Button
            type='primary'
            shape='round'
            className={props.CSVtype}
            size={props.size}
            icon={<IconSvg icon='fad fa-arrow-alt-to-bottom' />}
            {...props}
        >
          <Typography.Text>{props.text || 'CSV'}</Typography.Text>
        </Button>
        {props.tipText &&
            <Typography.Text>
              <Space size={4}>
                {props.tipText}
              </Space>
            </Typography.Text>
        }
      </DownloadWrapper>
    </>
  )
}

/* 创建 */
const CreateOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <CreateWrapper>
        <Button type='primary' {...props} >{props.text || t('All.Operation.Create.create')}</Button>
      </CreateWrapper>
    </>
  )
}

/* 生成 */
const GenerateOperation = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <GenerateWrapper>
        <Button
            type='primary'
            shape='round'
            className={props.CSVtype}
            size={props.size}
            icon={<IconSvg icon='fad fa-file-alt' />}
            {...props}
        >
          <Typography.Text>{props.text || 'Generate'}</Typography.Text>
        </Button>
        {/* progressSlot: 可由调用方在按钮与 tipText 之间注入自定义内容（如进度条） */}
        {props.progressSlot}
        {props.tipShow &&
            <Typography.Text type='danger'>
              <Space size={4} align='center' className='generate-operation-error-tip'>
                <ExclamationCircleOutlined />
                {props.tipText}
              </Space>
            </Typography.Text>
        }
        {props.tipText && !props.tipShow &&
            <Typography.Text>
              <Space size={4}>
                {props.tipText}
              </Space>
            </Typography.Text>
        }
      </GenerateWrapper>
    </>
  )
}

// 查看当前报警列表
const ViewOperation = (props) => {
    const {t, i18n} = useTranslation(); //语言包
    const [open, setOpen] = useState(false);
    const [refreshCurrentAlarmData, setRefreshCurrentAlarmData] = useState(0);
    const navigate = useNavigate();

    const showDrawer = () => {
        setOpen(true);
        setRefreshCurrentAlarmData(refreshCurrentAlarmData + 1);
    };

    const onClose = () => {
        setOpen(false);
    };

    const goToAlarm = () => {
        setOpen(false);
        navigate('/alarm', {
            state: {
                tabType: 'mask'
            }
        });
    };

    return (
        <>
            <ViewWrapper>
                <Button
                    type='primary'
                    shape='round'
                    size={'large'}
                    onClick={showDrawer}
                    {...props}
                >
                    <Typography.Text>{props.text || t('All.Operation.View.viewCurrentAlert')}</Typography.Text>
                </Button>
            </ViewWrapper>
            <Drawer
                className='DrawerRackGroupDetail'
                onClose={onClose}
                open={open}
                title={t('All.Operation.View.viewCurrentAlert')}
                push={false}
            >
                <CurrentAlarmTableList psIds={props.psIds} allPs={false}
                                       psInfoList={props.psInfoList} refreshKey={refreshCurrentAlarmData}
                                       onPageChange={(value) => goToAlarm()}/>
            </Drawer>
        </>
    );
}

const CancelIconOperation = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    setIsShow(props.isShow ?? true);
  }, [props.isShow]);

  useEffect(() => {
    setIsDisabled(props.disabled ?? false);
  }, [props.disabled]);

  return (
    <CancelIconWrapper className={`${isShow ? 'Show' : 'isHide'} ${props.type || ''}`}>
      <Tooltip placement="top" title={t('All.Operation.cancel')}>
        <Button
          size={props.size || 'small'}
          disabled={isDisabled}
          type="text"
          danger
          icon={<CloseOutlined />}
          onClick={props.onClick}
        />
      </Tooltip>
    </CancelIconWrapper>
  );
};

const SaveIconOperation1 = (props) => {
  const { t } = useTranslation();
  const [isShow, setIsShow] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    setIsShow(props.isShow ?? true);
  }, [props.isShow]);

  useEffect(() => {
    setIsDisabled(props.disabled ?? false);
  }, [props.disabled]);

  return (
    <SaveIconWrapper1 className={`${isShow ? 'Show' : 'isHide'} ${props.type || ''}`}>
      <Tooltip placement="top" title={t('All.Note.Tips.Tooltip.save')}>
        <Button
          size={props.size || 'small'}
          disabled={isDisabled}
          type="text"
          icon={<SaveOutlined />}
          onClick={props.onClick}
        />
      </Tooltip>
    </SaveIconWrapper1>
  );
};

export { ListOperation, AddOperation, EditOperation, BackToTopIconOperation, SwitchIconOperation, DelectIconOperation, EditIconOperation, ResetIconOperation, TransformIconOperation, ChartIconOperation, SetIconOperation, SaveIconOperation, SyncOperation, DetailOperation, FoldIconOperation, CopyOperation, LinkTextOperation, BlockOperation, UnblockOperation, VerifyOperation, DownloadOperation, GenerateOperation, ViewOperation, NoticeOperation, DownloadHelpOperation,CreateOperation, CancelIconOperation, SaveIconOperation1 }
